import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";
import "../../style/admin-departments.css"; // Reusing department styles for consistency

export default function States() {
  const navigate = useNavigate();

  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================= FETCH =================
  const fetchStates = async () => {
    try {
      setLoading(true);
      const res = await API.get("/states");
      setStates(res.data.data);
    } catch (err) {
      console.error("Failed to fetch states", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  // ================= TOGGLE =================
  const toggleStatus = async (id) => {
    try {
      await API.patch(`/states/${id}/toggle`);
      fetchStates();
    } catch (err) {
      console.error("Toggle state status failed", err);
      alert(err.response?.data?.message || "Failed to toggle state status");
    }
  };

  // ================= DELETE =================
  const deleteStateItem = async (id) => {
    if (!window.confirm("Are you sure you want to delete this state?")) return;

    try {
      await API.delete(`/states/${id}`);
      fetchStates();
    } catch (err) {
      console.error("Delete state failed", err);
      alert(err.response?.data?.message || "Failed to delete state");
    }
  };

  return (
    <div className="admin-dept-page">
      {/* ================= HEADER ================= */}
      <div className="admin-dept-header">
        <h1>States</h1>

        <button
          className="add-dept-btn"
          onClick={() => navigate("/admin/states/add")}
        >
          + Add State
        </button>
      </div>

      {/* ================= LOADING ================= */}
      {loading && <p className="loading-text">Loading...</p>}

      {/* ================= EMPTY ================= */}
      {!loading && states.length === 0 && (
        <p className="empty-text">No states found</p>
      )}

      {/* ================= TABLE ================= */}
      {!loading && states.length > 0 && (
        <div className="admin-dept-table">
          <table className="table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {states.map((stateItem) => (
                <tr key={stateItem._id}>
                  {/* CODE */}
                  <td style={{ fontWeight: "700" }}>{stateItem.code}</td>

                  {/* NAME */}
                  <td>{stateItem.name}</td>

                  {/* STATUS */}
                  <td>
                    <span
                      className={`status-badge ${
                        stateItem.active ? "active" : "inactive"
                      }`}
                    >
                      {stateItem.active ? "Available Now" : "Coming Soon"}
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td className="actions-cell">
                    <div className="actions">
                      <button
                        className="btn-toggle"
                        onClick={() => toggleStatus(stateItem._id)}
                      >
                        {stateItem.active ? "Disable" : "Enable"}
                      </button>

                      <button
                        className="btn-delete"
                        onClick={() => deleteStateItem(stateItem._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
